import { Button, ButtonProps, SvgIcon } from '@mui/material'
import { IconCopy } from '@tabler/icons-react'
import { toast } from 'sonner'

export type CopyToClipboardButtonProps = {
  label: string
  content: string
  onCopy?: () => void
} & ButtonProps

export const CopyToClipboardButton = ({
  label,
  content,
  onCopy,
  ...props
}: CopyToClipboardButtonProps) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content)
      toast.success('Copied to clipboard!')
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
      toast.error('Failed to copy to clipboard')
    }
    onCopy?.()
  }

  return (
    <Button
      onClick={handleCopy}
      startIcon={
        <SvgIcon fontSize="small">
          <IconCopy />
        </SvgIcon>
      }
      disableRipple
      {...props}
    >
      {label}
    </Button>
  )
}
